import { render, staticRenderFns } from "./AirtelTransactionDetail.vue?vue&type=template&id=3df5229f&scoped=true"
import script from "./AirtelTransactionDetail.vue?vue&type=script&lang=js"
export * from "./AirtelTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./AirtelTransactionDetail.vue?vue&type=style&index=0&id=3df5229f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5229f",
  null
  
)

export default component.exports